export default {
    setCurrentHash(state, hash) {
        state.currentHash = hash;
    }
}
